import * as t from 'io-ts';

import {
  AnalyticsFilterRelationsEnum,
  AnalyticsFilterTypesEnum,
  AnalyticsInboxScopeFiltersEnum,
  AnalyticsTagModesEnum,
} from '../../../../models/api/analyticsSavedViewModel';
import {makeEnumRuntimeType, RAccountIdRef} from '../../../../models/api/apiTypes';

/*
 * Constants.
 */

export const ANALYTICS_FILTERS_TAG_RELATION = 'tagRelation';
export const ANALYTICS_FILTERS_TAG_MODE = 'tagMode';

export const DEFAULT_FILTERS_STATE = {
  [AnalyticsFilterTypesEnum.ACCOUNTS]: undefined,
  [AnalyticsFilterTypesEnum.CHANNELS]: undefined,
  [AnalyticsFilterTypesEnum.INBOXES]: AnalyticsInboxScopeFiltersEnum.ALL_SHARED_INBOXES,
  [AnalyticsFilterTypesEnum.TAGS]: undefined,
  [AnalyticsFilterTypesEnum.FULL_TAGS]: undefined,
  [AnalyticsFilterTypesEnum.EXCLUDE_TAGS]: undefined,
  [AnalyticsFilterTypesEnum.TEAMMATES]: undefined,
  [AnalyticsFilterTypesEnum.TEAMS]: undefined,
  [ANALYTICS_FILTERS_TAG_RELATION]: AnalyticsFilterRelationsEnum.OR,
  [ANALYTICS_FILTERS_TAG_MODE]: AnalyticsTagModesEnum.TAG_STILL_ON_CONV,
  [AnalyticsFilterTypesEnum.WITHOUT_TAGS]: false,
};

export const EMPTY_FILTERS_STATE = {
  [AnalyticsFilterTypesEnum.ACCOUNTS]: undefined,
  [AnalyticsFilterTypesEnum.CHANNELS]: undefined,
  [AnalyticsFilterTypesEnum.INBOXES]: undefined,
  [AnalyticsFilterTypesEnum.TAGS]: undefined,
  [AnalyticsFilterTypesEnum.FULL_TAGS]: undefined,
  [AnalyticsFilterTypesEnum.EXCLUDE_TAGS]: undefined,
  [AnalyticsFilterTypesEnum.TEAMMATES]: undefined,
  [AnalyticsFilterTypesEnum.TEAMS]: undefined,
  [ANALYTICS_FILTERS_TAG_RELATION]: AnalyticsFilterRelationsEnum.OR,
  [ANALYTICS_FILTERS_TAG_MODE]: AnalyticsTagModesEnum.TAG_STILL_ON_CONV,
  [AnalyticsFilterTypesEnum.WITHOUT_TAGS]: false,
};

/*
 * Runtime types.
 */

export const RAnalyticsPanelFiltersStateDirty = t.type({
  [AnalyticsFilterTypesEnum.ACCOUNTS]: t.union([t.undefined, t.readonlyArray(RAccountIdRef)]),
  [AnalyticsFilterTypesEnum.TAGS]: t.union([t.undefined, t.readonlyArray(t.number)]),
  [AnalyticsFilterTypesEnum.EXCLUDE_TAGS]: t.union([t.undefined, t.readonlyArray(t.number)]),
  [AnalyticsFilterTypesEnum.FULL_TAGS]: t.union([t.undefined, t.readonlyArray(t.number)]),
  [AnalyticsFilterTypesEnum.INBOXES]: t.union([
    t.undefined,
    t.readonlyArray(t.number),
    makeEnumRuntimeType(AnalyticsInboxScopeFiltersEnum),
  ]),
  [AnalyticsFilterTypesEnum.CHANNELS]: t.union([t.undefined, t.readonlyArray(t.number)]),
  [AnalyticsFilterTypesEnum.TEAMMATES]: t.union([t.undefined, t.readonlyArray(t.number)]),
  [AnalyticsFilterTypesEnum.TEAMS]: t.union([t.undefined, t.readonlyArray(t.number)]),
  [ANALYTICS_FILTERS_TAG_RELATION]: makeEnumRuntimeType(AnalyticsFilterRelationsEnum),
  [ANALYTICS_FILTERS_TAG_MODE]: makeEnumRuntimeType(AnalyticsTagModesEnum),
  [AnalyticsFilterTypesEnum.WITHOUT_TAGS]: t.boolean,
});

/*
 * Types.
 */

export interface AnalyticsPanelFiltersState
  extends Readonly<t.TypeOf<typeof RAnalyticsPanelFiltersStateDirty>> {}

export type FiltersStateKey = keyof AnalyticsPanelFiltersState;
